export const ProductName = [
    { label: 'Lenovo 3rd Generation', value: '1' },
  ];
export const WareHouse = [
    { label: 'Lavish Warehouse', value: '1' },
    { label: 'Quaint Warehouse', value: '2' },
    { label: 'Traditional Warehouse', value: '3' },
    { label: 'Cool Warehouse', value: '4' },
    { label: 'Overflow Warehouse', value: '5' },
    { label: 'Nova Storage Hub', value: '6' },
    { label: 'Retail Supply Hub', value: '7' },
    { label: 'EdgeWare Solutions', value: '8' },
  ];
export const Store = [
    { label: 'Electro Mart', value: '1' },
    { label: 'Quantum Gadgets', value: '2' },
    { label: 'Prime Bazaar', value: '3' },
    { label: 'Gadget World', value: '4' },
    { label: 'Volt Vault', value: '5' },
  ];
export const Category = [
    { label: 'Laptop', value: '1' },
  ];
export const Period = [
    { label: 'Month', value: '1' },
    { label: 'Year', value: '2' },
  ];
export const Warehouse = [
    { label: 'Manufacture', value: '1' },
    { label: 'Transport', value: '2' },
    { label: 'Customs', value: '3' },
  ];
export const Stores = [
    { label: 'Online', value: '1' },
    { label: 'Offline', value: '2' },
  ];
export const PaperSize = [
    { label: 'A3', value: '1' },
    { label: 'A4', value: '2' },
    { label: 'A5', value: '3' },
    { label: 'A6', value: '4' },
  ];
export const ResponsiblePerson = [
    { label: 'Steven', value: '1' },
    { label: 'Gravely', value: '2' },
  ];
export const Shop = [
    { label: 'Selosy', value: '1' },
    { label: 'Logerro', value: '2' },
  ];
export const Addition = [
    { label: 'Addition', value: '1' },
    { label: 'Addition', value: '2' },
    { label: 'Addition', value: '3' },
  ];
export const WarehouseFrom  = [
    { label: 'Lobar Handy', value: '1' },
    { label: 'Quaint Warehouse', value: '2' },
  ];
export const WarehouseTo  = [
    { label: 'Selosy', value: '1' },
    { label: 'Quaint Warehouse', value: '2' },
  ];
export const From  = [
    { label: 'Store 1', value: '1' },
  ];
export const To  = [
    { label: 'Store 2', value: '1' },
  ];
export const Status  = [
    { label: 'Sent', value: '1' },
    { label: 'Pending', value: '2' },
  ];
export const CustomerName  = [
    { label: 'Customer Name', value: '1' },
  ];
export const Supplier  = [
    { label: 'Supplier Name', value: '1' },
  ];
export const OrderStatus = [
  { label: "Pending", value: "Pending" },
  { label: "Completed", value: "Completed" }
];
export const PaymentType  = [
    { label: 'Completed', value: '1' },
    { label: 'Inprogress', value: '2' },
  ];
export const AccountType  = [
    { label: 'Current Account', value: '1' },
    { label: 'Salary Account', value: '2' },
  ];
export const AccountStatus  = [
    { label: 'Active', value: '1' },
    { label: 'closed', value: '2' },
  ];
export const HOD  = [
    { label: 'Mitchum Daniel', value: '1' },
    { label: 'Susan Lopez', value: '2' },
  ];
export const Employee  = [
    { label: 'Computers', value: '1' },
  ];
export const BestStores  = [
    { label: 'All', value: '1' },
    { label: 'Carl Evans', value: '2' },
    { label: 'Minerva Rameriz', value: '3' },
    { label: 'Robert Lamon', value: '4' },
  ];
export const Products  = [
    { label: 'Lenovo IdeaPad 3', value: '1' },
    { label: 'Beats Pro', value: '2' },
  ];
export const Country  = [
    { label: 'USA', value: '1' },
    { label: 'India', value: '2' },
    { label: 'French', value: '3' },
    { label: 'Australia', value: '4' },
  ];
export const State  = [
    { label: 'Alaska', value: '1' },
    { label: 'Mexico', value: '2' },
    { label: 'Tasmania', value: '3' },
  ];
export const City  = [
    { label: 'Anchorage', value: '1' },
    { label: 'Tijuana', value: '2' },
    { label: 'Hobart', value: '3' },
  ];

